import { AxiosError } from "axios";

import { http } from "../http/HttpService";
import { registerGlobalService } from "../service-provider/ServiceRegistry";
import ApiErrorFactory from "./ApiErrorFactory";
import { configuration } from "../configuration/ConfigurationService";
import { authentication } from "../authentication/Authentication";
import { globalModule } from "../service-provider/GlobalModule";
import { Endpoint } from "./ApiEndpoints";

export interface ApiLastAccessedOrganization {
  get: (endpoint: Endpoint) => Promise<any>;
}

export class ApiLastAccessedOrganizationService implements ApiLastAccessedOrganization {
  get = async (endpoint: Endpoint) => {
    let configurationContent = await configuration.get();

    try {
      const request = await this.getRequest(
        configurationContent,
        "application/json; charset=utf-8; application/problem+json"
      );

      const endpointUrl = this.getEndpointUrl(endpoint);
      let response = await http.get(configurationContent.api + endpointUrl, request);
      return response.data;
    } catch (err) {
      throw ApiErrorFactory.create(err as AxiosError<any>);
    }
  };

  put = async (endpoint: Endpoint, data?: any) => {
    let configurationContent = await configuration.get();

    try {
      const request = await this.getRequest(
        configurationContent,
        "application/json; charset=utf-8; application/problem+json"
      );

      const endpointUrl = this.getEndpointUrl(endpoint);
      return await http.put(configurationContent.api + endpointUrl, data, request);
    } catch (err) {
      throw ApiErrorFactory.create(err as AxiosError<any>);
    }
  };

  private async getRequest(configurationContent: any, contentType: string) {
    const accessToken = await authentication.getAccessToken();

    return {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": contentType,
        "Ocp-Apim-Subscription-Key": configurationContent.subscription_key,
      },
    };
  }

  private getEndpointUrl(endpoint: Endpoint) {
    let parsedEnpoint = endpoint;
    endpoint.routeParams?.forEach((element, index) => {
      parsedEnpoint.url = endpoint.url.replace("{" + index + "}", element.toString());
    });

    if (endpoint.queryParams) parsedEnpoint.url = `${parsedEnpoint.url}?${endpoint.queryParams}`;

    return parsedEnpoint.url;
  }
}

export const apiLastAccessedOrganization = new ApiLastAccessedOrganizationService();
globalModule.apiLastAccessedOrganization = apiLastAccessedOrganization;
export default registerGlobalService(
  apiLastAccessedOrganization as ApiLastAccessedOrganizationService
);
